module.exports = __webpack_public_path__ + "img/cetificate-student-front1.81718c14.png";